import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import { CloudUpload, CheckCircle } from "@material-ui/icons";
import { useSelector } from "react-redux";
import FormErrorMessageBeforeUploading from "../../shared/ErrorMessages/FormErrorMessageBeforeUploading";

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	width: "60%",
	bgcolor: "background.paper",
	boxShadow: 24,
	p: 4,
};

export default function OneDriveAccountType({
	setAccType,
	launchPicker,
	accType,
	formik,
	handleDisableButton,
}) {
	const [open, setOpen] = React.useState(false);
	const isFilesPicked = useSelector(
		(state) => state.oneDriveContent.isFilesPicked
	);

	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const handleAccountChoice = () => {
		launchPicker();
		handleClose();
	};

	const handleCheckboxChange = (event) => {
		setAccType(event.target.value);
	};

	return (
		<div>
			<Button
				fullWidth
				variant="contained"
				color={isFilesPicked ? "success" : "primary"}
				sx={{ gap: 2 }}
				onClick={handleOpen}
				disabled={typeof handleDisableButton === 'function' ? handleDisableButton() : false}
			>
				{isFilesPicked ? (
					<>
						<CheckCircle />
						Files Submitted... Click here to Edit
					</>
				) : (
					<>
						<CloudUpload /> Upload From Cloud
					</>
				)}
			</Button>
			<FormErrorMessageBeforeUploading errors={formik?.errors} />
			<Modal
				open={open}
				onClose={handleClose}
				aria-labelledby="modal-title"
				aria-describedby="modal-description"
			>
				<Box sx={style}>
					<Typography id="modal-title" variant="h6" component="h2">
						Choose OneDrive Account Type
					</Typography>
					<Typography id="modal-description" sx={{ mt: 2 }}>
						Do you want to upload files with a OneDrive business
						account or a OneDrive personal account?
					</Typography>
					<Box sx={{ mt: 4 }}>
						<FormControlLabel
							control={
								<Checkbox
									checked={accType === "common"}
									onChange={handleCheckboxChange}
									value="common"
								/>
							}
							label="Business Account"
						/>
						<FormControlLabel
							control={
								<Checkbox
									checked={accType === "consumers"}
									onChange={handleCheckboxChange}
									value="consumers"
								/>
							}
							label="Personal Account"
						/>
					</Box>
					<Box
						sx={{
							mt: 4,
							display: "flex",
							justifyContent: "flex-end",
						}}
					>
						<Button
							variant="contained"
							onClick={handleAccountChoice}
							disabled={!accType}
						>
							Launch OneDrive
						</Button>
					</Box>
				</Box>
			</Modal>
		</div>
	);
}
